import React from 'react';
import classNames from 'classnames';

import './style.scss';

export default class HeaderSelector extends React.PureComponent {
  render() {
    const { label, value, onClickPrev, onClickNext, hasPrev, hasNext } = this.props;
    const name = !value || value === 'null' ? 'no name' : value;

    return (
      <div className='HeaderSelector'>
        <div className='HeaderSelector_Label'>{ label }</div>
        <div className='HeaderSelector_Input'>
          <div className={ classNames('HeaderSelector_Arrow--left', {
            HeaderSelector_Arrow_Active: hasPrev
          })} onClick={ onClickPrev } >{'<'}</div>
          <div className='HeaderSelector_Value'>{ name }</div>
          <div className={ classNames('HeaderSelector_Arrow--right', {
            HeaderSelector_Arrow_Active: hasNext
          })} onClick={ onClickNext }>{'>'}</div>
        </div>
      </div>
    );
  }
}